import React, { ReactNode } from "react";
import "./PageContent.css"

interface PageContentProps {
  children: ReactNode;
}

export const PageContent = ({ children}: PageContentProps) => {
  return (
    <div id="pageContent">
      {children}
    </div>
  );
};
